export default {
  transactionProduct: null,
  transactionPayment: null,
  transactionTypes: null,
  transactionHistory: null
}